import Entity from '../entity'
import Product from './product';

export default class Brand extends Entity<number>{
    name: string  = null;
    description: string  = null;
    coverImageUrl: string  = null;
    tenantId: number  = null;
    remark: string  = null;
    products: Array<Product>;
}